module.exports = __webpack_public_path__ + "/images/ico-social-color-goodreads.5e03ffd.svg";